import { useCallback, useEffect, useState } from 'react';

import {
  getNavCollapsed,
  setNavCollapsed,
} from '@/lib/localStorage/navCollapsedState';

export function useNavCollapsed(orgId: string | undefined): {
  isCollapsed: boolean;
  setCollapsed: (collapsed: boolean) => void;
} {
  const [isCollapsed, setIsCollapsedState] = useState<boolean>(() =>
    getNavCollapsed(orgId)
  );

  useEffect(() => {
    setIsCollapsedState(getNavCollapsed(orgId));
  }, [orgId]);

  const setCollapsed = useCallback(
    (collapsed: boolean) => {
      if (orgId) {
        setNavCollapsed(orgId, collapsed);
      }
      setIsCollapsedState(collapsed);
    },
    [orgId]
  );

  return { isCollapsed, setCollapsed };
}
